export default "__VITE_ASSET__DMsMHn5X__"